const helps = [
  {
    icon: "ri-focus-3-line",
    title: "精準匹配",
    desc: "把你的項目介紹給真正對AI有興趣且願意投早期的家族辦公室，避免浪費雙方時間，每一次介紹都是精心篩選。",
    color: "bg-amber-50 border-amber-100",
    iconColor: "text-amber-600",
  },
  {
    icon: "ri-presentation-line",
    title: "免費反饋",
    desc: "幫你優化 Pitch Deck，並給出市場與投資人視角的建議，讓你的項目以最佳狀態呈現給潛在投資人。",
    color: "bg-stone-50 border-stone-100",
    iconColor: "text-stone-700",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "生態資源",
    desc: "分享 Cyberport、HKSTP、AI Subsidy Scheme 等最新申請資訊與機會，讓你第一時間掌握香港AI生態的支援資源。",
    color: "bg-amber-50 border-amber-100",
    iconColor: "text-amber-600",
  },
];

export default function HowIHelpSection() {
  return (
    <section id="how-i-help" className="py-24 bg-stone-950">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-amber-500 text-sm font-semibold tracking-widest uppercase mb-3">For AI Founders</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight" style={{ fontFamily: "'Noto Serif TC', serif" }}>
            我如何幫助香港AI初創？
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {helps.map((item, i) => (
            <div
              key={i}
              className={`border rounded-xl p-8 flex flex-col gap-5 hover:-translate-y-1 transition-transform duration-300 ${item.color}`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-white/80 ${item.iconColor}`}>
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className="text-stone-900 text-xl font-bold">{item.title}</h3>
              <p className="text-stone-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div className="mt-14 rounded-xl bg-amber-600/10 border border-amber-600/20 px-8 py-7 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-white font-semibold text-lg">準備好讓更多人認識你的項目了嗎？</p>
            <p className="text-white/50 text-sm mt-1">提交只需 5 分鐘，我會在 7 天內親自回覆。</p>
          </div>
          <a
            href="#submit"
            className="bg-amber-600 hover:bg-amber-500 text-white font-bold px-7 py-3.5 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            立即提交項目 →
          </a>
        </div>
      </div>
    </section>
  );
}
